import {
  Braces,
  Gauge,
  Layers,
  Search,
  TrendingUp,
  Users,
} from "lucide-react";
import { ServicePrinciple } from "@/lib/types";

export const servicePrinciples: ServicePrinciple[] = [
  {
    number: "01",
    icon: Search,
    title: "Strategic Thinking",
    description:
      "We begin every project with research and clarity. By understanding your business, audience and goals, we create solutions rooted in insight — not assumption.",
  },
  {
    number: "02",
    icon: Layers,
    title: "Creative Execution",
    description:
      "Our team transforms strategy into powerful visual experiences. From branding to digital design, every detail is crafted with precision and purpose rather than configured from a template.",
  },
  {
    number: "03",
    icon: TrendingUp,
    title: "Measurable Impact",
    description:
      "Design is only valuable when it performs. We build scalable systems that increase engagement, strengthen trust and support long-term growth — and we agree the number before the work starts.",
  },
  {
    number: "04",
    icon: Users,
    title: "User-Centric Process",
    description:
      "Research, flows and prototypes come before pixels. On Chic & Charming that meant cutting click-depth, because seventy percent of fashion shoppers prefer imagery over interface.",
  },
  {
    number: "05",
    icon: Gauge,
    title: "SEO & Performance",
    description:
      "Core Web Vitals, semantic markup, indexing and analytics are launch gates, not follow-up tickets. A beautiful site nobody can find is an expensive brochure.",
  },
  {
    number: "06",
    icon: Braces,
    title: "Transparent Delivery",
    description:
      "Fixed stages, named owners and a weekly build you can open. You own the source files, repositories and design systems on final payment — no licence, no lock-in.",
  },
];
